import courseShowNotification
  from "../excellentCourse/courseIntroduction/components/courseIntroduction/courseShowNotification";

const userInfoKey = 'user-info-4.2';
const kpKey = 'kp';
const courseKpKey = 'courseKp';
const courseIdKey = 'courseId';
const courseTypeIdKey = 'courseTypeId';
const bankSearch = 'bank-search';
const bankViewSearch = 'bank-view-search';
const businessTypesKey = 'business-types'
var storage = {
  setUserInfo(userInfo) {
    localStorage.setItem(userInfoKey, JSON.stringify(userInfo));
  }, getUserInfo() {
    return JSON.parse(localStorage.getItem(userInfoKey));
  }, clearUserInfo() {
    localStorage.removeItem(userInfoKey);
  }, setKp(kp) {
    localStorage.setItem(kpKey, JSON.stringify(kp));
  }, getKp() {
    return JSON.parse(localStorage.getItem(kpKey));
  }, clearKp() {
    localStorage.removeItem(kpKey);
  }, setCourseId(courseId) {
    localStorage.setItem(courseIdKey, JSON.stringify(courseId));
  }, getCourseId() {
    return JSON.parse(localStorage.getItem(courseIdKey));
  }, clearCourseId() {
    localStorage.removeItem(courseIdKey);
  }, setCourseTypeId(courseTypeId) {
    localStorage.setItem(courseTypeIdKey, JSON.stringify(courseTypeId));
  }, getCourseTypeId() {
    return JSON.parse(localStorage.getItem(courseTypeIdKey));
  }, clearCourseTypeId() {
    localStorage.removeItem(courseTypeIdKey);
  }, getBankSearch() {
    return JSON.parse(localStorage.getItem(bankSearch));
  }, setBankSearch(search) {
    localStorage.setItem(bankSearch, JSON.stringify(search));
  }, getBankViewSearch() {
    return JSON.parse(localStorage.getItem(bankViewSearch));
  }, setBankViewSearch(search) {
    localStorage.setItem(bankViewSearch, JSON.stringify(search));
  }, clearBankSearchId() {
    localStorage.removeItem(bankSearch);
  }, setCourseKp(courseKp) {
    localStorage.setItem(courseKpKey, JSON.stringify(courseKp));
  }, getCourseKp() {
    return JSON.parse(localStorage.getItem(courseKpKey));
  }, clearCourseKp() {
    localStorage.removeItem(courseKpKey);
  }, getBusinessTypes() {
    let types;
    const userInfo = this.getUserInfo()
    if (userInfo) {
      const keyName = userInfo.userType === 'teacher' ? 'mteacherPowerDTOS' : 'mschoolPowerDTOS';
      if(userInfo[keyName] === undefined) {
          return ['2'];
      }
      const power = userInfo[keyName][0]
      types = power ? power.type.split(',') : ''
    }
    return types
  }
}
export default storage;



// WEBPACK FOOTER //
// ./src/components/tools/storage.js